import * as React from "react";
const IconStrikethroughCopy = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M61 20.5H33V4h16.4c.6 0 1-.4 1-1s-.4-1-1-1H14.6c-.6 0-1 .4-1 1s.4 1 1 1H31v16.5H3c-.6 0-1 .4-1 1s.4 1 1 1h28V61c0 .6.4 1 1 1s1-.4 1-1V22.5h28c.6 0 1-.4 1-1s-.4-1-1-1" />
  </svg>
);
export default IconStrikethroughCopy;
